/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_ProcessingInputs */

const vi_confirm_return_processing = /** @type {(inputs: Confirm_Return_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xử lý...`)
};

/**

* @param {Confirm_Return_ProcessingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_processing = /** @type {((inputs?: Confirm_Return_ProcessingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_ProcessingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_processing(inputs)
});